import React from 'react';
import { Link } from 'react-router-dom';

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || 'Something went wrong while rendering this page.',
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Frontend render error boundary caught an error.', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[linear-gradient(180deg,#fffdf9_0%,#f8efe6_45%,#fdf8f1_100%)] px-4 py-10">
          <div className="mx-auto max-w-2xl rounded-[32px] border border-[#E7DED3] bg-white p-8 shadow-[0_30px_80px_rgba(58,44,32,0.12)]">
            <p className="text-xs uppercase tracking-[0.24em] text-[#A2968A]">Rendering issue</p>
            <h1 className="mt-3 font-serif text-4xl leading-none text-[#221B17]">This page failed to load cleanly.</h1>
            <p className="mt-4 text-sm leading-7 text-[#7E766F]">{this.state.errorMessage}</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-full bg-[#1F1A17] px-6 py-3 text-sm font-medium text-white"
              >
                Return home
              </Link>
              <button
                onClick={() => window.location.reload()}
                className="rounded-full border border-[#E7DED3] bg-white px-6 py-3 text-sm font-medium text-[#221B17]"
              >
                Reload page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
